<template>
<div class="hl-wid ww3 ubox importcvent">
  <div style="display: flex;">
    <form class="user-form login" style="width: 0; flex-grow: 1;">
      <div class="import-text" v-if="!parsed">
        <textarea v-model="importData" style="height: 350px; margin-bottom: 10px; margin-top: 0" />
        <button class="main" v-on:click.prevent="doParse">Parse</button>        
      </div>
      <div v-else>
        <div class="pkg-select">
          <label>Pkg</label>
          <div class="select">
            <span style="white-space: nowrap; overflow: hidden; display: block; margin-right: 20px;">{{ packageOpts[newPackage] || "" }}</span>
            <select v-model="newPackage">
              <option v-for="(option, optVal) in packageOpts" :value="optVal">{{ option }}</option>
            </select>
          </div>
          <label>Expiry</label>
          <datepicker v-model="newExpires" placeholder />
        </div>
        
        <table class="import-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users">
              <td>{{ user.firstname }}</td>
              <td>{{ user.lastname }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.package }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <form class="user-form login imported" style="width: 33%; margin-left: 10px; flex-grow: 0">
      <div class="uf-row to-c" v-if="parsed">
        <button class="main" v-on:click.prevent="doImport">Import</button>
      </div>
      <div class="import-info" v-if="importInfo.message">
        <div class="uf-row to-c">
          <span>{{ importInfo.message }}</span>
        </div>
      </div>
      <div></div>
    </form>
  </div>
</div>
</template>

<script>
import moment from 'moment';
export default {
  data: ()=>({
    importData: "",
    importInfo: {
      message: null,
      username: null,
      password: null,
    },
    importedProfile: null,
    parsed: false,
    users: [],
    packages: [],
    videosById: {},
    newExpires: null,
    newPackage: null,
  }),
  computed: {
    packageOpts() {
      var result={};
      for(var pkg of this.packages) {
        if (pkg.title && pkg.individual!=1) {
          result[pkg.id]=pkg.title;
        } else if (pkg.title && pkg.individual==1) {
          for(var vid of pkg.videos || []) {
            result[pkg.id+"-"+vid.id]="  "+vid.title;
          }
        }
      }
      return result;
    },
  },
  methods: {
    doParse() {
      this.parsed=true;
      this.users=[];
      var iData=this.importData.split("\n").map((a)=>a.trim()).filter((a)=>a);
      for(var row of iData) {
        var fields=row.split("\t");
        if (fields[0].toLowerCase()=="full name" || (fields[1] && fields[1].toLowerCase()=="full name"))
          continue;
        var firstname=fields[0].split(", ")[1];
        var lastname=fields[0].split(", ")[0];
        var packages={
          "1 Month Live Class + Recording": "1 Month",
          "Live Class": "Live only",
          "Live Class + Recording": "Live + Rec",
        };
        this.users.push({
          firstname,
          lastname,
          confirmation: fields[4],
          date: fields[5],
          email: fields[1],
          phone: fields[6],
          package: packages[fields[7]],
          address: fields[9],
          location: fields[8],
          country: fields[10],
          amount: fields[12],
        });
      }
    },
    async doImport() {
      for(var i in this.users) {
        await this.doImportUser(this.users[i]);
        this.importInfo.message="Imported "+(i*1+1)+" of "+this.users.length+" users";
      }
      this.users=[];
      this.importData="";
    },
    async doImportUser(user) {
      var existingUser=(await api.list("User", {email: user.email})).items[0];
      if (existingUser) {
      } else {
        //this.importInfo.password=(await api.pin()).password;
        this.importInfo.password="PilatesAlliance";
        var newUser={
          active: "Yes",
          username: user.email,
          newPassword: this.importInfo.password,
          firstname: user.firstname,
          lastname: user.lastname,
          title: user.title,
          email: user.email,
          currency: 'USD',
        }
        existingUser=(await api.create("User", newUser, true)).item;
      }
      await api.create("Payment", {
        userid: existingUser.id,
        status: "captured",
        sstatus: "cancelled",
        payment: {type: "admin", price: 0},
        videogroup: this.newPackage.split("-")[0],
        video: this.newPackage.split("-")[1],
        startDate: moment().format("YYYY-MM-DD"),
        endDate: this.newExpires,
        pastDueDate: this.newExpires,
      });
      await this.doWelcomeMail(existingUser)
    },
    async doWelcomeMail(user) {
      await api.action("User", user.id, "activationMail", {password: this.importInfo.password, event: this.packageOpts[this.newPackage]});
      this.importedProfile=null;
      this.importInfo.password=null;
    },
    async manualActivationMail(userId) {
//       var password=(await api.pin()).password;
      var password="PilatesAlliance";
      var u=(await api.update("User", userId, {newPassword: password}, true)).item;
      if (u) {
        await api.action("User", u.id, "activationMail", {password: password, event: this.packageOpts[this.newPackage]});
      }
    },
    async loadPackages() {
      this.packages=(await api.list("VideoGroup", {})).items || [];
      for(var pkg of this.packages)
        if (pkg.individual==1)
          this.loadVideos(pkg);
    },
    async loadVideos(pkg) {
      var videos=(await api.list("Video", {group: pkg.id}, ["title:ASC"])).items || [];
      for(var video of videos)
        this.$set(this.videosById, video.id, video);
      this.$set(pkg, "videos", videos);
    },
  },
  mounted() {
    this.loadPackages();
  },
}
</script>
